import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "geotab-user-report" }
const _hoisted_2 = /*#__PURE__*/_createVNode("td", null, "First Name", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("td", null, "Last Name", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("td", null, "Geotab Username", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("td", null, "Geotab ID", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("td", null, "Employee Number", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("td", null, "Is Driver?", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("td", null, "Company", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("td", null, "Company Address", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("td", null, "Carrier Number", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("td", null, "License Number", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("td", null, "License Province", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("td", null, "HOS Rule Setting", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("td", null, "Country", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("td", null, "Language", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", null, "Driver: " + _toDisplayString(_ctx.userReport.firstName) + " " + _toDisplayString(_ctx.userReport.lastName), 1),
    _createVNode("table", null, [
      _createVNode("tbody", null, [
        _createVNode("tr", null, [
          _hoisted_2,
          _createVNode("td", null, _toDisplayString(_ctx.userReport.firstName), 1)
        ]),
        _createVNode("tr", null, [
          _hoisted_3,
          _createVNode("td", null, _toDisplayString(_ctx.userReport.lastName), 1)
        ]),
        _createVNode("tr", null, [
          _hoisted_4,
          _createVNode("td", null, _toDisplayString(_ctx.userReport.name), 1)
        ]),
        _createVNode("tr", null, [
          _hoisted_5,
          _createVNode("td", null, _toDisplayString(_ctx.userReport.id), 1)
        ]),
        _createVNode("tr", null, [
          _hoisted_6,
          _createVNode("td", null, _toDisplayString(_ctx.userReport.employeeNo), 1)
        ]),
        _createVNode("tr", null, [
          _hoisted_7,
          _createVNode("td", null, _toDisplayString(_ctx.userReport.isDriver), 1)
        ]),
        _createVNode("tr", null, [
          _hoisted_8,
          _createVNode("td", null, _toDisplayString(_ctx.userReport.companyName), 1)
        ]),
        _createVNode("tr", null, [
          _hoisted_9,
          _createVNode("td", null, _toDisplayString(_ctx.userReport.companyAddress), 1)
        ]),
        _createVNode("tr", null, [
          _hoisted_10,
          _createVNode("td", null, _toDisplayString(_ctx.userReport.carrierNumber), 1)
        ]),
        _createVNode("tr", null, [
          _hoisted_11,
          _createVNode("td", null, _toDisplayString(_ctx.userReport.licenseNumber), 1)
        ]),
        _createVNode("tr", null, [
          _hoisted_12,
          _createVNode("td", null, _toDisplayString(_ctx.userReport.licenseProvince), 1)
        ]),
        _createVNode("tr", null, [
          _hoisted_13,
          _createVNode("td", null, _toDisplayString(_ctx.userReport.hosRuleSet), 1)
        ]),
        _createVNode("tr", null, [
          _hoisted_14,
          _createVNode("td", null, _toDisplayString(_ctx.userReport.countryCode), 1)
        ]),
        _createVNode("tr", null, [
          _hoisted_15,
          _createVNode("td", null, _toDisplayString(_ctx.userReport.language), 1)
        ])
      ])
    ])
  ]))
}